import { apiRoutes } from '@features/campaigns/shared/consts/apiRoutes';
import { CampaignSubmitResponse } from '@features/campaigns/shared/types/campaignSubmit.ts';
import { apiClient } from '@shared/api/ApiClient.ts';
import { CampaignId } from '@shared/types/campaign';

export async function submitCampaign(campaignId: CampaignId): Promise<CampaignSubmitResponse | null> {
  return await apiClient.post<never, CampaignSubmitResponse>(apiRoutes.submitCampaign(campaignId));
}
